define('services/interactionService',[
    'lib/knockout',
    'lib/lodash4',
    'models/ChatList',
    'services/apiCore',
    'services/callService',
    'services/chatService'
], function (
    ko,
    _,
    ChatList,
    apiCore,
    callService,
    chatService
) {
    'use strict';

    var CALL_STATE = {
        ALERTING:   'alerting',
        PREVIEW:    'preview',
        CONNECTING: 'connecting'
    };

    var totalACD = 0;

    /**
     * Responsible for providing the list of current interactions for the logged in user.
     */
    return {

        acdCount: function () {
            return totalACD;
        },
        /**
         * List of currently active interactions sorted by state
         * @return {Array} the list of active interactions
         */
        activeInteractions: ko.computed(function () {
            var total = 0;

            total += callService.activeAgentCalls().length;

            var interactions = callService.activeAgentCalls();

            if (chatService.activeChats().length > 0) {
                // consolidate the list of external chats into a single model so they can be displayed in the same view
                var chatList = new ChatList();
                interactions.push(chatList);
                total += chatService.activeChats().length;
            }

            totalACD = total;
            return interactions.sort(function (left, right) {
                if (left.state() === right.state()) {
                    return 0;
                } else if (left.state() === CALL_STATE.ALERTING ||
                           left.state() === CALL_STATE.PREVIEW ||
                           left.state() === CALL_STATE.CONNECTING) {
                    return -1;
                } else if (right.state() === CALL_STATE.ALERTING ||
                           right.state() === CALL_STATE.PREVIEW ||
                           right.state() === CALL_STATE.CONNECTING) {
                    return 1;
                }
                return 0;
            });
        })
    };
});

